const main = `/`;
const createStatement = `/create-statement`;
const editStatement = `/edit-statement/:id`;
const invoice = `/invoice/:id`;
const shareInvoice = `/invoice/:id/share`;
const dashboard = `/dashboard`;
const prepayment = `/prepayment`;
const payments = `/payments`;
const payment = `/payments/:id`;
const invoiceProcessing = `/invoice-processing`;
const invoiceCreation = `/invoice-creation`;

export {
  main,
  createStatement,
  editStatement,
  invoice,
  dashboard,
  payments,
  payment,
  shareInvoice,
  prepayment,
  invoiceProcessing,
  invoiceCreation
};
